import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';
import {IUserAccessUserProfile} from '../access';

//#region INTERFACE IFeatureUser
export interface IFeatureUser extends IUserAccessFeature, Object {
  crudAccess?: IUserAccessUserProfile;
}

//#endregion

//#region CONST _FEATURE_USER_DEFAULT
export const _FEATURE_USER_DEFAULT: Readonly<IFeatureUser & Object> = {
  displayText: NavigationPageEnumHumanReadable.UserDefaults,
  feature: NavigationPageEnum.User,
  ref: SettingsReferenceEnum.undefined,
  standalone: false,
};
//#endregion